/* tslint:disable:member-ordering */
import {ApplicationRef, Component, ComponentFactoryResolver, HostListener, Injector, NgZone, OnInit} from '@angular/core';
import {DoraLabelComponent} from './DoraWidget/dora-label/dora-label.component';
import {DoraDataGridComponent} from './DoraWidget/dora-data-grid/dora-data-grid.component';
// tslint:disable-next-line:max-line-length
import {DoraDataGridSelectorTabComponent} from './DoraWidget/dora-data-grid-selector/dora-data-grid-selector-tab/dora-data-grid-selector-tab.component';
import {DoraChartComponent} from './DoraWidget/dora-chart/dora-chart.component';
// tslint:disable-next-line:max-line-length
import {DoraChartTypeSettingLbComponent} from './DoraWidget/dora-chart-type-setting/dora-chart-type-setting-lb/dora-chart-type-setting-lb.component';
// tslint:disable-next-line:max-line-length
import {DoraDataGridSelectorLbComponent} from './DoraWidget/dora-data-grid-selector/dora-data-grid-selector-lb/dora-data-grid-selector-lb.component';
import {DoraRowsPreselectTabComponent} from './DoraWidget/dora-rows-preselect/dora-rows-preselect-tab/dora-rows-preselect-tab.component';
import {DoraRowsPreselectLbComponent} from './DoraWidget/dora-rows-preselect/dora-rows-preselect-lb/dora-rows-preselect-lb.component';
import {DoraColumnSelectorLbComponent} from './DoraWidget/dora-column-selector/dora-column-selector-lb/dora-column-selector-lb.component';
import {DoraTabComponent} from './DoraWidget/dora-tab/dora-tab.component';
import {DoraSeriesFromGridComponent} from './DoraWidget/dora-series-from-grid/dora-series-from-grid.component';
import {IPublisherInitializer} from './pusblisher/ipublisher-initializer';
import {IPublisherServiceInitializer} from './pusblisher/ipublisher-service-initializer';
import {PublisherService} from './pusblisher/publisher.service';
import {DoraCollapseExpandComponent} from './DoraWidget/dora-collapse-expand/dora-collapse-expand.component';
import {DoraGridTitleComponent} from './DoraWidget/dora-grid-title/dora-grid-title.component';
import {DoraGridNotesComponent} from './DoraWidget/dora-grid-data-notes/dora-grid-notes.component';
import {DoraRowsNotesComponent} from './DoraWidget/dora-rows-notes/dora-rows-notes.component';
import {DoraColumnPaginatorComponent} from './DoraWidget/dora-column-paginator/dora-column-paginator.component';
import {ActivatedRoute} from '@angular/router';
import {TypedJSON} from 'typedjson';
import {DataGrid} from './DoraData/data-grid';
import {WidgetBaseComponent} from './DoraWidget/widget-base/widget-base.component';
import {DoraChartPrintComponent} from './DoraWidget/dora-chart-print/dora-chart-print.component';
// tslint:disable-next-line:max-line-length
import {DoraDataGridSelectorTabScrollComponent} from './DoraWidget/dora-data-grid-selector/dora-data-grid-selector-tab-scroll/dora-data-grid-selector-tab-scroll.component';
import { DoraRowComponent } from './DoraWidget/dora-row/dora-row.component';
import {DoraSeriesValueComponent} from './DoraWidget/dora-series-value/dora-series-value.component';
import {DoraSeriesFromRowComponent} from './DoraWidget/dora-series-from-row/dora-series-from-row.component';
import {DoraSeriesSelectorComponent} from './DoraWidget/dora-series-selector/dora-series-selector.component';
import {TranslationService} from './TranslationMarkers/translation.service';
import {ITranslationInitializer} from './TranslationMarkers/itranslation-initializer';

@Component({
  selector: 'dora-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements IPublisherServiceInitializer, ITranslationInitializer {
  // All widgets created in page
  widgetsCreated: WidgetBaseComponent[] = [];


  title = 'DoraG';

  static readonly TAG_PREFIX = 'DAG-';

  private componentList = [
    {name: 'dora-label', type: DoraLabelComponent},
    {name: 'dora-data-grid', type: DoraDataGridComponent},
    {name: 'dora-data-grid-selector-tab', type: DoraDataGridSelectorTabComponent},
    {name: 'dora-data-grid-selector-tab-scroll', type: DoraDataGridSelectorTabScrollComponent},
    {name: 'dora-data-grid-selector-lb', type: DoraDataGridSelectorLbComponent},
    {name: 'dora-grid-notes', type: DoraGridNotesComponent},
    {name: 'dora-grid-title', type: DoraGridTitleComponent},
    {name: 'dora-chart', type: DoraChartComponent},
    {name: 'dora-chart-print', type: DoraChartPrintComponent},
    {name: 'dora-chart-type-setting-lb', type: DoraChartTypeSettingLbComponent},
    {name: 'dora-collapse-expand', type: DoraCollapseExpandComponent},
    {name: 'dora-column-paginator', type: DoraColumnPaginatorComponent},
    {name: 'dora-column-selector-lb', type: DoraColumnSelectorLbComponent},
    {name: 'dora-rows-notes', type: DoraRowsNotesComponent},
    {name: 'dora-rows-preselect-tab', type: DoraRowsPreselectTabComponent},
    {name: 'dora-rows-preselect-lb', type: DoraRowsPreselectLbComponent},
    {name: 'dora-row', type: DoraRowComponent},
    {name: 'dora-series-from-grid', type: DoraSeriesFromGridComponent},
    {name: 'dora-series-from-row', type: DoraSeriesFromRowComponent},
    {name: 'dora-tab', type: DoraTabComponent},
    {name: 'dora-series-value', type: DoraSeriesValueComponent},
    {name: 'dora-series-selector', type: DoraSeriesSelectorComponent},
  ];
  constructor(private injector: Injector,
              private applicationRef: ApplicationRef,
              private componentFactoryResolver: ComponentFactoryResolver,
              private publisherService: PublisherService,
              private translationService: TranslationService,
              private ngZone: NgZone) {


      this.translationService.initialize(this);
  }

    onTranslationInitialized() {
      // initialize publisher service
      this.publisherService.initialize(this);
    }

  onPublisherServiceInitialized(): void {
        // publisher are initialized: load widget
        // Add widgets to DOM dynamically
        this.componentList.forEach((componentName) => {
            const completeSelector = AppComponent.TAG_PREFIX + componentName.name;
            const elementsFound = document.querySelectorAll(completeSelector);

          // tslint:disable-next-line:prefer-for-of
            for (let idx = 0; idx < elementsFound.length; idx++ ) {
              const x = elementsFound[idx];

              console.log('found [' + AppComponent.TAG_PREFIX + componentName.name + ']');

              // Create element
              const fatherElement = document.createElement(componentName.name);

              // set attributes
              for (let i = 0; i < x.attributes.length; i++) {
                const attribute = x.attributes.item(i);

                fatherElement.setAttribute(attribute.name, attribute.value);
              }

              // Create the component and wire it up with the element
              // @ts-ignore
              const factory = this.componentFactoryResolver.resolveComponentFactory(componentName.type);
              const newComponentRef = factory.create(this.injector, [], fatherElement);

              const widgetCreated = newComponentRef._component;
              this.widgetsCreated.push(widgetCreated);


              // Attach to the view so that the change detector knows to run
              this.applicationRef.attachView(newComponentRef.hostView);



              // Add to the DOM
              x.appendChild(fatherElement);
            }

            // USE FOREACH ON DOM !!! not compliant with IExplorer
            // document.querySelectorAll(commpleteSelector).forEach(
            //     x => {
            //
            //       console.log('found [' + AppComponent.TAG_PREFIX + componentName.name + ']');
            //
            //         // Create element
            //       const fatherElement = document.createElement(componentName.name);
            //
            //         // set attributes
            //       for (let i = 0; i < x.attributes.length; i++) {
            //             const attribute = x.attributes.item(i);
            //
            //             fatherElement.setAttribute(attribute.name, attribute.value);
            //         }
            //
            //         // Create the component and wire it up with the element
            //         // @ts-ignore
            //       const factory = this.componentFactoryResolver.resolveComponentFactory(componentName.type);
            //       const newComponentRef = factory.create(this.injector, [], fatherElement);
            //
            //         // Attach to the view so that the change detector knows to run
            //       this.applicationRef.attachView(newComponentRef.hostView);
            //
            //
            //
            //         // Add to the DOM
            //       x.appendChild(fatherElement);
            //
            //     }
            // );
        });

      // tslint:disable-next-line:no-string-literal
        window['DoraGComponentReference'] = {
        zone: this.ngZone,
        refresh: () => this.runReferesh(),
        component: this,
      };

    }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.runReferesh();
  }
  runReferesh() {
    console.log('Called runReferesh()');

    // tslint:disable-next-line:prefer-for-of
    for (let idx = 0; idx < this.widgetsCreated.length; idx++ ) {
      this.widgetsCreated[idx].onRefresh();
    }
  }
}
